import { FileUpload } from '@/components/atoms'
import { Controller } from "react-hook-form"
import { useIntl } from 'react-intl'

const imageMock = new URL('./mockImage.png', import.meta.url).href

export const ImageUploader = ({ control, name, label }) => {
  const { formatMessage } = useIntl()

  return (
    <div className="border border-gray-500 rounded-lg p-6 h-fit">
      <Controller
        name={name}
        control={control}
        render={({ field }) => (<FileUpload
          acceptedExtensions=".jpg,.png"
          className=""
          description={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_IMAGE_UPLOADER' })}
          feedbackType="info"
          label={label}
          type="image"
          variant="default"
          imageUri={field.value}
          onUpload={() => {
            field.onChange(imageMock)
          }}
        />)}
      />
    </div>
  )
}